import React from 'react';
import { meetings } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const numberColors = ['text-brand', 'text-coral-ink', 'text-leaf-ink'];

/** The 10 complete meetings with what each one achieves */
export function MeetingsList() {
  return <section id="meetings" aria-labelledby="meetings-title" className="scroll-mt-4 bg-mist py-12 md:py-20" data-id="element-161" data-mp="7k54rdpa7xet">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-162" data-mp="3fzou41mu0vol">
        <SectionHeading id="meetings-title" eyebrow={meetings.eyebrow} title={meetings.title} sub={meetings.sub} data-id="element-163" data-mp="3bxldkylb30wg" />

        <ol className="mx-auto mt-8 grid max-w-[980px] gap-3 md:mt-12 md:grid-cols-2 md:gap-4" data-id="element-164" data-mp="3pxd05npw1pm2">
          {meetings.items.map((m, i) => <li key={m.n} className="flex gap-3 rounded-xl border border-mist-line bg-white p-5" data-id="element-165" data-mp="3kwoxu5w7lmcj" data-mpi={i}>
              <span className={`w-12 shrink-0 font-display text-[1.9rem] font-black leading-none ${numberColors[i % numberColors.length]}`} data-id="element-166" data-mp="155140jchs9xy">{m.n}</span>
              <div className="min-w-0" data-id="element-167" data-mp="17toovhxy7a3p">
                <h3 className="font-display text-[16px] font-extrabold uppercase leading-snug tracking-tight text-ink" data-id="element-168" data-mp="17sn9505zlzfn">{m.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-ink/75" data-id="element-169" data-mp="1hrcvb54x261p">{m.goal}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 flex max-w-[460px] justify-center" data-id="element-170" data-mp="1mp4lnupwxk3s">
          <CtaButton label={meetings.cta} microcopy={meetings.ctaMicrocopy} align="center" data-id="element-171" data-mp="p37728enlyx4" />
        </div>
      </div>
    </section>;
}